import React from 'react'
import { useNavigate } from 'react-router-dom';

import imageOne from '../../resource/donations/maintance/2.png'
import imageFour from '../../resource/donations/maintance/3.png'
import imageFive from '../../resource/donations/maintance/4.png'
import imageThree from '../../resource/donations/maintance/1.png'
import imageSix from '../../resource/donations/maintance/5 (1).png'
import TitleChnage from '../../Hook/TitleChnage'

const Maintenance = () => {
    TitleChnage("Maintenance")
        const navigate = useNavigate();
            
                const handleClick = (event) => {
            
                    const pathMap = {
                        maintainRequest : '/maintainRequest',
                    }
                
                    const path = event.currentTarget.id;
                    const targetPath = pathMap[path]
                
                    if (targetPath){
                      navigate(targetPath)
                    }
                  }
  return (
    <div className="maintenance-page inside-pages">
    <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
    </div>

    <h1 className='font-main p-4 mt-4'>Maintenance fund</h1>

    <div className=" mt-6 h4-bold">
        <div className='text-center'>
            <p >A place to have a home with the Buddha. </p>
            <p >A place to practice living the Dhamma. </p>
            <p >A place to uplift the noble Sangha.</p>
            <p >A place to show respect—Isn’t it a wonder?</p>

            <p className="mt-5">Make this place bright and shiny.</p>
            <p >Let your heart and mind be devoted to holy service.</p>
            <p >Devote your strength and memorize it daily.</p>
            <p >The gate to open the heaven of glory.</p>

        </div>
    </div>

    <p className="mt-6 h4 p-4">We invite you to support Bhaddeka Vihari Monastery and Meditation Centre by contributing to our Maintenance Fund, which ensures the smooth running of daily operations and the well-being of our resident monastic community. Your donation will help cover essential expenses such as utilities, administration, and travel, enabling the Sangha to fully dedicate themselves to their spiritual practice without concern for material needs.</p>
    <p className="mt-5 h4 p-4">In keeping with the tradition of Buddhist generosity, your support perpetuates the timeless bond between the Sangha and the lay community. By offering your assistance, you not only contribute to sustaining the Monastery but also foster your own spiritual growth, accumulating merit through compassionate action.</p>
    <p className="mt-5 h4 p-4">Your contribution will help foster a community rooted in mindfulness, compassion, and wisdom, creating a lasting impact for generations to come</p>

    <p className="mt-5 h4 p-4">Donate today to help preserve this sacred space for spiritual growth and practice. Your support ensures the Monastery’s continued ability to serve the community and uphold the Dhamma.</p>
    <p className="mt-5 h4 p-4">We are deeply grateful for your generosity.</p>

    

    <div className='btn-group2 mt-6'>
    <img src={imageFive} alt="Right Top Image" width={300} />
        <img src={imageFour} alt="Right Top Image" width={300} />
        
    </div>

    <p className="h4 text-black p-4 text-center mt-6">Ongoing Projects :</p>
    <p className="h4 p-4 text-center mt-4"><a href="#">https://test.evisionlk.com/about-us/</a></p>

    <div className="p-4 mt-6 text-center">
    <div className="mt-6 calander-box align-item-center">
            <div className="c-details text-left">
                <h2 className='intro-text '>Futher More Details : </h2>
                <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                <p className="font-p">Mr Gamini : 0422 069 359</p>
                <p className="font-p">WhatsApp : 0422 069 359</p>
                <p className="font-p">E-mail : info@bvp.org.au</p>
            </div>
            <div className="d-button">
                  <img
          src={imageSix}
          alt="Right Top Image"
          width={300}
          id='maintainRequest' onClick={handleClick}
         
          className="curser-pointer"
        />
                    </div>
        </div>
        </div>

        <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image"  width={600}  />
    </div>

</div>
  )
}

export default Maintenance